/**
 * 数组转树形结构
 * @param option
 * @returns {*[]}
 */
export function toTreeData(option) {
    var _a, _b;
    if (Array.isArray(option)) {
        option = {
            data: arguments[0],
            idField: arguments[1],
            parentIdField: arguments[2],
            childrenField: arguments[3],
            parentId: arguments[4],
            addParentIds: arguments[5],
            parentIdsField: arguments[6],
            parentIds: arguments[7]
        };
    }
    const data = option.data;
    const idField = option.idField || option.idKey || "id";
    const parentIdField = option.parentIdField || option.pidKey || "parentId";
    const childrenField = option.childrenField || option.childKey || "children";
    const parentIdIsNull = typeof option.parentId === "undefined" && typeof option.pid === "undefined";
    const parentId = parentIdIsNull ? [] : (_a = option.parentId) != null ? _a : option.pid;
    const addParentIds = (_b = option.addParentIds) != null ? _b : option.addPIds;
    const parentIdsField = option.parentIdsField || option.parentsKey || "parentIds";
    const parentIds = option.parentIds;
    if (parentIdIsNull) {
        data.forEach((d) => {
            let flag = true;
            for (let i = 0; i < data.length; i++) {
                if (d[parentIdField] == data[i][idField]) {
                    flag = false;
                    break;
                }
            }
            if (flag) {
                parentId.push(d[parentIdField]);
            }
        });
    }
    const result = [];
    data.forEach((d) => {
        if (d[idField] == d[parentIdField]) {
            throw new Error(["data error: {", idField + ": ", JSON.stringify(d[idField]), parentIdField + ": ", JSON.stringify(d[parentIdField]), "}"].join(""));
        }
        const isArr = Array.isArray(parentId);
        const isParent = isArr ? parentId.includes(d[parentIdField]) : d[parentIdField] == parentId;
        if (isParent) {
            const r = {...d};
            const children = toTreeData({
                data,
                idField,
                parentIdField,
                childrenField,
                parentId: d[idField],
                addParentIds,
                parentIdsField,
                parentIds: (parentIds != null ? parentIds : []).concat([d[idField]])
            });
            if (children.length > 0) {
                r[childrenField] = children;
            }
            if (addParentIds) {
                r[parentIdsField] = parentIds != null ? parentIds : [];
            }
            result.push(r);
        }
    });
    return result;
}